// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.

// frontend/src/components/enterprise-admin/organization/OrganizationOverviewSection.jsx

import React from "react";
import {
  Field,
  Select,
  TextInput,
} from "../../../design-system/components";
import OrganizationSectionCard from "./OrganizationSectionCard";

const INDUSTRIES = [
  "Technology",
  "Healthcare",
  "Financial Services",
  "Retail",
  "Manufacturing",
  "Professional Services",
  "Education",
  "Government",
  "Energy",
  "Telecommunications",
];

export default function OrganizationOverviewSection({ draft, setField }) {
  const isStandardIndustry =
    !draft.industry || INDUSTRIES.includes(draft.industry);

  return (
    <OrganizationSectionCard
      eyebrow="Organization overview"
      title="Authoritative tenant identity"
      description="Maintain the legal and operating identity used throughout OASYS."
    >
      <div className="enterprise-admin-organization-fields">
        <Field label="Organization name" required>
          <TextInput
            value={draft.organization_name || ""}
            onChange={(event) =>
              setField("organization_name", event.target.value)
            }
            placeholder="Acme Inc."
          />
        </Field>

        <Field label="Legal name" optionalLabel="Optional">
          <TextInput
            value={draft.legal_name || ""}
            onChange={(event) => setField("legal_name", event.target.value)}
            placeholder="Acme Holdings, Inc."
          />
        </Field>

        <Field label="Industry">
          <Select
            value={isStandardIndustry ? draft.industry || "" : "__other__"}
            onChange={(event) => {
              const value = event.target.value;
              setField("industry", value === "__other__" ? "" : value);
            }}
          >
            <option value="">Select industry</option>
            {INDUSTRIES.map((industry) => (
              <option key={industry} value={industry}>
                {industry}
              </option>
            ))}
            <option value="__other__">Other</option>
          </Select>
        </Field>

        {!isStandardIndustry ? (
          <Field label="Custom industry">
            <TextInput
              value={draft.industry || ""}
              onChange={(event) => setField("industry", event.target.value)}
              placeholder="Enter industry"
            />
          </Field>
        ) : null}

        <Field label="Employee range">
          <Select
            value={draft.employee_range || ""}
            onChange={(event) =>
              setField("employee_range", event.target.value)
            }
          >
            <option value="">Select range</option>
            <option value="1-50">1–50</option>
            <option value="51-200">51–200</option>
            <option value="201-1000">201–1,000</option>
            <option value="1000+">1,000+</option>
          </Select>
        </Field>

        <Field label="Organization status">
          <Select
            value={draft.organization_status || "active"}
            onChange={(event) =>
              setField("organization_status", event.target.value)
            }
          >
            <option value="active">Active</option>
            <option value="review">Under review</option>
            <option value="inactive">Inactive</option>
          </Select>
        </Field>
      </div>
    </OrganizationSectionCard>
  );
}
